import { render, staticRenderFns } from "./foodPackLogDetails.vue?vue&type=template&id=5cb917bc&scoped=true&"
import script from "./foodPackLogDetails.vue?vue&type=script&lang=js&"
export * from "./foodPackLogDetails.vue?vue&type=script&lang=js&"
import style0 from "./foodPackLogDetails.vue?vue&type=style&index=0&id=5cb917bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb917bc",
  null
  
)

export default component.exports